import {FC, ProviderExoticComponent, ProviderProps, ReactNode} from "react";

export function createConcernProvider<C,P extends {children:ReactNode}>(Provider: ProviderExoticComponent<ProviderProps<C | null>>, createConcern: (props:P) => C, displayName: string): FC<P> {
    const providerComponent = (props: P) => {
        const concern = createConcern(props)
        return (
            <Provider value={concern}>
                {props.children}
            </Provider>
        )
    }
    providerComponent.displayName = displayName
    return providerComponent
}
